import { io } from "socket.io-client";
import { sessionManager } from "../utils/sessionManager";
import { SOCKET_URL } from "../utils/runtimeConfig";

let socket = null;
let joinedEstabelecimentoId = null;

const getCurrentEstabelecimentoId = () => {
  try {
    const value = localStorage.getItem("estabelecimento_id");
    return value ? String(value) : null;
  } catch {
    return null;
  }
};

const syncRoom = () => {
  if (!socket || !socket.connected) return;
  const estabelecimentoId = getCurrentEstabelecimentoId();
  if (!estabelecimentoId) return;

  if (joinedEstabelecimentoId && joinedEstabelecimentoId !== estabelecimentoId) {
    socket.emit("leave_estabelecimento", joinedEstabelecimentoId);
  }

  if (joinedEstabelecimentoId !== estabelecimentoId) {
    joinedEstabelecimentoId = estabelecimentoId;
    console.log("[socket] joining estabelecimento:", estabelecimentoId);
    socket.emit("join_estabelecimento", estabelecimentoId);
  }
};

export const initSocket = () => {
  if (socket) return socket;
  if (!sessionManager.estaAutenticado()) return null;

  const url = SOCKET_URL;

  socket = io(url, {
    transports: ["websocket", "polling"],
    withCredentials: true,
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 500,
    reconnectionDelayMax: 5000,
    timeout: 20000,
  });

  socket.on("connect", () => {
    console.log("[socket] connected");
    syncRoom();
  });

  socket.on("reconnect", () => {
    syncRoom();
  });

  socket.on("connect_error", (err) => {
    console.warn("[socket] connect_error:", err?.message || err);
  });

  if (process.env.NODE_ENV !== "production") {
    socket.onAny((event, ...args) => {
      try {
        console.debug("[socket.event]", event, args);
      } catch (e) {
        // ignore
      }
    });
  }

  socket.on("disconnect", () => {
    console.log("[socket] disconnected");
  });

  return socket;
};

export const syncSocketEstabelecimento = () => {
  if (!socket) return;
  if (socket.connected) {
    syncRoom();
    return;
  }

  try {
    socket.connect();
  } catch {
    // noop
  }
};

export const closeSocket = () => {
  if (!socket) return;
  socket.disconnect();
  socket = null;
  joinedEstabelecimentoId = null;
};
